import COUNTRY_DATA from '@/constants/country-data'

const getSupportedCountries = () => {
  return COUNTRY_DATA.filter(({ enabled }) => enabled)
}

const findCountryByKey = (fieldName, fieldValue) => {
  const supportedCountries = getSupportedCountries()

  return (
    supportedCountries.find((country) => country[fieldName] === fieldValue) ||
    null
  )
}

const findCountryByCountryCode = (countryCode) =>
  findCountryByKey('countryCode', `${countryCode}`)

const getSupportedPaymentMethods = (iosCode2) => {
  const foundCountry = findCountryByKey('isoCode2', iosCode2)

  if (!foundCountry) {
    return []
  }

  return foundCountry.supportedPaymentMethods || []
}

const getPhoneNumberPlaceholder = (countryCode) => {
  const foundCountry = findCountryByCountryCode(countryCode)

  if (!foundCountry) {
    return ''
  }

  return foundCountry.phoneFormatPlaceholder || ''
}

const getTermsAndConditionsContent = (iosCode2, language) => {
  const foundCountry = findCountryByKey('isoCode2', iosCode2)

  if (!foundCountry) {
    return []
  }

  return foundCountry.termsAndConditions[language]
}

const getTermsAndConditionsContentForCashback = (iosCode2, language) => {
  const foundCountry = findCountryByKey('isoCode2', iosCode2)

  if (!foundCountry) {
    return []
  }

  return foundCountry.termsAndConditionsCashback[language]
}

const getTermsAndConditionsContentForSubscription = (iosCode2, language) => {
  const foundCountry = findCountryByKey('isoCode2', iosCode2)

  if (!foundCountry) {
    return []
  }

  return foundCountry.termsAndConditionsSubscription?.[language] || []
}

export {
  findCountryByKey,
  getSupportedCountries,
  findCountryByCountryCode,
  getSupportedPaymentMethods,
  getPhoneNumberPlaceholder,
  getTermsAndConditionsContent,
  getTermsAndConditionsContentForCashback,
  getTermsAndConditionsContentForSubscription,
}
